import { forwardRef, type Ref, type SVGProps } from "react";

function SvgErrorCreditCard(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#error-credit-card_svg__a)">
        <circle
          cx={88}
          cy={60}
          r={50}
          fill="#fff"
          stroke="url(#error-credit-card_svg__b)"
          strokeWidth={20}
        />
        <path
          stroke="#B01921"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M73.5 54.667h30M80.167 63h.016m6.65 0h3.334M73.5 51.334a5 5 0 0 1 5-5h20a5 5 0 0 1 5 5v13.333a5.003 5.003 0 0 1-5 5h-20a5 5 0 0 1-5-5z"
        />
      </g>
      <rect width={30.712} height={30.712} x={36.394} y={14.644} fill="#B01921" rx={15.356} />
      <rect
        width={30.712}
        height={30.712}
        x={36.394}
        y={14.644}
        stroke="#fff"
        strokeWidth={0.787}
        rx={15.356}
      />
      <path
        fill="#fff"
        d="M51.018 35.125V33.58h1.545v1.545zm0-7.385v-2.75h1.531v2.75l-.354 4.62h-.808z"
      />
      <defs>
        <linearGradient
          id="error-credit-card_svg__b"
          x1={88}
          x2={87.57}
          y1={10}
          y2={85.533}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#F9E1E1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="error-credit-card_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgErrorCreditCard);
export default ForwardRef;
